var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolSubRenewals01 = function SvgSolSubRenewals01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_sub_renewals-01_svg2__a",
    x1: 36.64,
    x2: 190.24,
    y1: 180.06,
    y2: 12.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_sub_renewals-01_svg2__a",
    id: "sol_sub_renewals-01_svg2__b",
    x1: 34.41,
    x2: 188.01,
    y1: 178.01,
    y2: 10.29
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_sub_renewals-01_svg2__a",
    id: "sol_sub_renewals-01_svg2__c",
    x1: 32.83,
    x2: 186.43,
    y1: 176.57,
    y2: 8.85
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100.77 127.93c2.29 0 4.59-.87 6.33-2.62l16.42-16.42c.93-.93 1.44-2.17 1.44-3.48s-.51-2.55-1.44-3.48l-6-6c-1.86-1.86-5.11-1.86-6.97 0l-9.78 9.78-5.36-5.36a4.937 4.937 0 0 0-6.97 0l-6 6c-.93.93-1.44 2.17-1.44 3.48s.51 2.55 1.44 3.48l11.99 12a8.9 8.9 0 0 0 6.33 2.62Zm-8.84-22.83 6.07 6.07c1.48 1.48 4.07 1.48 5.54 0l10.5-10.5 4.73 4.73-15.78 15.78a3.126 3.126 0 0 1-4.42 0l-11.36-11.36 4.73-4.72Z",
    style: {
      fill: "url(#sol_sub_renewals-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2 115.29c-1.61 0-2.91 1.3-2.91 2.91v15.51c0 7.16 5.82 12.98 12.98 12.98h67.43c7.16 0 12.98-5.82 12.98-12.98V72.54c0-7.16-5.82-12.98-12.98-12.98h-2.66v-3.34c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v3.34h-12.94v-3.34c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v3.34H96.52v-3.34c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v3.34H77.76v-3.34c0-1.61-1.3-2.91-2.91-2.91s-2.91 1.3-2.91 2.91v3.34h-2.65c-7.16 0-12.98 5.82-12.98 12.98v31.99c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V84.15h55.34c1.61 0 2.91-1.3 2.91-2.91s-1.3-2.91-2.91-2.91H62.13v-5.78c0-3.95 3.21-7.15 7.16-7.15h2.65v3.34c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V65.4H90.7v3.34c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V65.4h12.94v3.34c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V65.4h12.94v3.34c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V65.4h2.66c3.94 0 7.15 3.21 7.15 7.15v5.78h-12.72c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h12.72v49.56c0 3.95-3.21 7.15-7.15 7.15H69.27c-3.95 0-7.16-3.21-7.16-7.15V118.2c0-1.61-1.3-2.91-2.91-2.91",
    style: {
      fill: "url(#sol_sub_renewals-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.99 2.98c-31.28 0-60.82 15.22-79.01 40.71-.93 1.31-.63 3.13.68 4.06 1.31.94 3.12.63 4.06-.68 17.1-23.95 44.86-38.26 74.27-38.26 50.28 0 91.19 40.91 91.19 91.19s-40.91 91.19-91.19 91.19c-37.59 0-70.73-22.45-84.68-57.27l12.23-4.45c12.05 29.63 40.39 48.73 72.45 48.73 43.12 0 78.19-35.08 78.19-78.19S146.1 21.8 102.99 21.8c-36.41 0-67.7 24.71-76.09 60.09-.49 2.07.74 4.13 2.8 4.69l3.96 1.06-20.93 23.6L6.4 80.33l3.16.85c1.02.27 2.11.12 3.02-.42a3.98 3.98 0 0 0 1.81-2.45 90.6 90.6 0 0 1 7.32-19.71c.73-1.43.16-3.19-1.27-3.92a2.92 2.92 0 0 0-3.92 1.27 96.4 96.4 0 0 0-7.31 19.1l-4.27-1.14c-1.32-.36-2.7 0-3.7.93-1 .94-1.43 2.3-1.15 3.64l7.3 35.67c.38 1.84 1.74 3.29 3.56 3.78s3.72-.09 4.97-1.49L40.08 89.2c.91-1.02 1.22-2.42.82-3.73a3.89 3.89 0 0 0-2.74-2.66l-5.13-1.37C41.41 49.66 69.92 27.63 103 27.63c39.9 0 72.37 32.46 72.37 72.37S142.9 172.37 103 172.37c-29.94 0-56.38-18-67.36-45.85a4.904 4.904 0 0 0-6.27-2.82l-13.9 5.06a4.92 4.92 0 0 0-2.81 2.6 4.9 4.9 0 0 0-.1 3.83c14.63 37.56 50.12 61.83 90.44 61.83 53.49 0 97.01-43.52 97.01-97.01S156.48 2.98 102.99 2.98",
    style: {
      fill: "url(#sol_sub_renewals-01_svg2__c)"
    }
  }));
};
export default SvgSolSubRenewals01;